<template>
    <div class="templete_box banking_box">
        <!-- 展示区 -->
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" placeholder="融资提单号"></el-input>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.status" placeholder="融资状态" @visible-change="getSelectList('pledgestatus')">
                <el-option v-for="(list,index) in selectMap.pledgestatus" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.payer_id" placeholder="开证公司" @visible-change="getSelectList('pledgeissuing')">
                <el-option v-for="(list,index) in selectMap.pledgeissuing" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号"></el-input>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
             <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <!-- <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span> -->
            </div>
        </div>
        <!-- 
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn" @click="Edit">修改</el-button>
            <el-button class="funcPublicBtn" @click="addFee">添加费用</el-button>
            <img src="/icon/huoquan.png" class="huoquanImg" @click="openCargo">
            <div class="upimgBtnBox" v-if="module.indexOf(',purchase-upload-files,')!=-1" @click="bacthUpFile">
                <div class="upFileBtnImg"></div>
                <div class="upimgBtnTitle">上传文件</div>
            </div>
        </div> -->
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="pledge.overdue.orders" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @relativefile="relativeFile" @getToforeclosure="getToforeclosure" @rowClick="rowClick"></tabletem>
        </div>
        <div class="total">
            <div class="total_left">合计</div>
            <div class="total_right">
                <span>即将到期单数: {{tot.number}}单</span>
                <span>未赎方数: {{tot.remain_cube}}m³</span>
                <span>未赎金额: ￥{{tot.remain_amount}}</span>
            </div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <el-dialog v-dialog-drag :visible.sync="isShowEditfinance" class="eldialog eldialogLine" :modal="false" title="融资单修改" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <!-- :rules="feeFormRules" -->
                <el-form :model="financeFeeForm"  class="clearfix dialogFormB">
                    <el-form-item  label="付汇日期：">
                        <el-date-picker v-model="financeFeeForm.pay_date" type="date" placeholder="" size="mini" :disabled="statusList[0]==2"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="实付汇率：">
                        <el-input v-model="financeFeeForm.pay_rate" :disabled="statusList[0]==2"></el-input>
                    </el-form-item>
                    <el-form-item  label="付税日期：">
                        <el-date-picker v-model="financeFeeForm.tax_date" type="date" placeholder="" size="mini" :disabled="statusList[0]==2"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="发票号码：">
                        <el-input v-model="financeFeeForm.invoice_no" :disabled="statusList[0]==2"></el-input>
                    </el-form-item>
                    <div class="dialogBtnList clearfix">
                        <el-button class="dialogBtn funcPublicBtn" @click="isShowEditfinance=!isShowEditfinance">取消</el-button>
                        <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!-- 货权明细 START -->
        <el-dialog v-dialog-drag :visible.sync="cargodetailsDialog" class="eldialog specTable" width="500px" :modal="false" title="货权明细" custom-class="full_dialog">
            <el-table :data="cargoDetail" :summary-method="getTableSummaries"   border show-summary stripe highlight-current-row  size="mini" height="100%" style="min-height:200px;max-height:400px">
                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column label="开证公司" prop="issuing" show-overflow-tooltip></el-table-column>
                <el-table-column label="监管金额" prop="finance_amount" show-overflow-tooltip></el-table-column>
                <el-table-column label="质押保证金" prop="deposit" show-overflow-tooltip></el-table-column>
                <el-table-column label="可发金额" prop="usable_amount" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="height: 34px;text-align: left;">
                <div style="padding: 5px;font-size: 15px;">
                    <!-- <span style="padding-left: 25px;">合计：{{cubeTotal.cube}}m³</span>
                    <span style="padding-left: 25px;">外币金额：{{cubeTotal.foreign_amount}}</span>   -->
                </div>
            </div>
       </el-dialog>
        <!-- 货权明细 END -->
        <el-dialog v-dialog-drag :visible.sync="isShowCost" class="eldialog eldialogLine" :modal="false" title="添加费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form :model="feeForm" :rules="feeFormRules" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="feeForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="feeForm.contract_no" readonly></el-input>
                    </el-form-item>
                    <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-input v-model="feeForm.bill_lading_no_copy" readonly></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-select v-model="feeForm.bill_lading_no" multiple collapse-tags clearable @visible-change="feeChange('bill_lading_no')">
                            <el-option v-for="(list,index) in bill_lading_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item  label="货柜号：" prop="container_no">
                        <el-select v-model="feeForm.container_no" multiple collapse-tags clearable @visible-change="feeChange('container_no')">
                            <el-option v-for="(list,index) in container_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="feeForm.fee_id"  @visible-change="getSelectList('purchaseCost')" clearable>
                            <el-option v-for="list in selectMap.purchaseCost" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="feeForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="feeForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="feeForm.is_invoice">
                            <el-option :value="1" label="是"></el-option>
                            <el-option :value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="feeForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveFee">添加保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'融资提单详情'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="融资提单：" prop="customer_id">
                            <el-input v-model="form_params.order_sn" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <el-form-item  label="开证公司：" prop="salesman_id">
                            <el-input v-model="form_params.issuing" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="融资类型：" prop="sales_time">
                            <el-input v-model="form_params.finance_type_text" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="代缴税金：" prop="sales_time">
                            <el-input v-model="form_params.agent_tax_status" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="totalCal">
                    <div class="totalName">合计：</div>
                    <div class="totalNumber">融资货值:{{form_params.finance_amount}}</div>  
                    <div class="totalNumber" v-if="form_params.agent_tax_status=='是'">代缴税金:{{form_params.agent_tax}}</div>      
                    <div class="totalNumber">融资总额:{{form_params.finance_amount_total}}</div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson" v-if="form_params.creator_name">制单人：{{form_params.creator_name}}</div>
                </div>
                <div>

                </div>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-doc-out-export,')!=-1" @click="exportExcel">导出</el-button>
                        <el-button class="funcPublicBtn" @click="dialogVisible=!dialogVisible">关闭</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- 文件上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleFile" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="文件上传" custom-class="full_dialog">
            <div class="upFileOutBox clearfix">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload">
                    <img src="/icon/upfile.png" class="uploadFileAdd">
                    <div class="uploadTitle">点击文件上传</div>
                </el-upload>
                <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                    <div class="upFile">{{item.name}}</div>
                    <img src="/icon/top-delete-suspension.png" class="upFileRemove" @click="upFileRemove(item.url)"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveFile">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleFile = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 文件上传 END -->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="pledge.overdue.orders" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 单据字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="pledge.order.info" :filterDialogVisible="filterDialogVisibleB" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleB = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import bus from "../../../eventBus";
    import tabletem from '../../../components/table.vue';
    import pagination from '../../../components/pagination.vue';
    import relativeFile from '../../../components/downloadRelativeFile.vue'
    const initStatistical = {
        finance_order_count: 0,
        finance_pledge_cube: "0.0000",
        finance_pledge_amount: "0.00",
        payment_interest: '0.00',
        payment_amount: '0.00',
        finance_overdue_count: '0'
    };
    const initDetailItem = {
       
    };
    const initDetailList = [initDetailItem];
    export default {
        data() {
            return {
                module:localStorage.dw_erp_power_code,
                statistical: this.$cloneJson(initStatistical),
                params:{
                    start_time:"",
                    end_time:"",
                    contract_no:"",
                    bill_lading_no:"",
                    status:[],
                    payer_id:[],
                    remark:"",
                    page:1,
                    per_page:50,
                },
                last_page:1,
                total:0,
                tot:{},
                selectRow:[],
                list:[],
                fields:"",
                filter:"",
                filters: [],
                filterDialogVisible:false,
                filterDialogVisibleB:false,
                isGlobal:false,
                tableCol:[
                     {colName:"融资单日期",colKey:"finance_date",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购合同号",colKey:"contract_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"订单状态",colKey:"status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资提单号",colKey:"order_sn",colWidth:80,isSetWidth:true,isCanRongClick:true,isColor:true,},
                    {colName:"开证公司",colKey:"issuing",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资类型",colKey:"finance_type_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"代缴税金",colKey:"agent_tax_status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付汇日期",colKey:"pay_date",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付税日期",colKey:"tax_date",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库日期",colKey:"inbound_date",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"到期日期",colKey:"expiry_date",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"当前天数",colKey:"pledge_days",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"当前融资利率",colKey:"finance_rate",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"明细详情",colKey:"finance_detail",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货物品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资件数",colKey:"finance_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资方数",colKey:"finance_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资货值",colKey:"finance_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"代缴税金",colKey:"tax",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实付汇率",colKey:"pay_rate",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"代理费用",colKey:"agent_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"银行费用",colKey:"bank_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"保险费用",colKey:"insure_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资总金额",colKey:"finance_amount_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"赎货详情",colKey:"redeem_detail",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"到期剩余天数",colKey:"due_day",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,
                        htmlNodeFunc(row) {
                        let color = row['due_day'] !=0 ? 'red' : '';
                            return `<span style="color:${color}">${row['due_day']}</span>`;
                        }},
                    {colName:"未赎方数",colKey:"remain_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"未赎金额",colKey:"remain_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"当前利息",colKey:"interest",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"当前仓储费",colKey:"storage_fee",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"其他费用",colKey:"other_cost",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"发票号",colKey:"invoice_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"关联文件",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isRelativeFile:true},
                    {colName:"备注",colKey:"remark",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                tableLoading:false,
                start_time:"",
                end_time:"",
                isShowEditfinance:false,
                financeFeeForm:{
                    pay_date:"",
                    pay_rate:"",
                    tax_date:"",
                    invoice_no:"",
                },
                selectMap:{
                    pledgeissuing:[],
                    pledgestatus:[],
                    purchaseCost:[],
                },
                cargodetailsDialog:false,
                cargoDetail:[],
                isShowCost:false,
                feeForm:{
                    fee_date:"",
                    finance_order_id:"",
                    contract_no:[],
                    bill_lading_no_copy:"",
                    bill_lading_no:"",
                    fee_id:"",
                    payee:"",
                    amount:"",
                    is_invoice:0,
                    remark:""
                },
                feeFormRules:{
                    fee_date:[ { required: true, message: '请填写日期', trigger: 'blur' }],
                    // purchase_id:[ { required: true, message: '请填写采购合同', trigger: 'blur' }],
                    contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                    // bill_lading_no:[ { required: true, message: '请填写提单号', trigger: 'blur' }],
                    fee_id:[ { required: true, message: '请填写费用名称', trigger: 'blur' }],
                    // payee:[ { required: true, message: '请填写收款单位(人)', trigger: 'blur' }],
                    amount:[ { required: true, message: '请填写金额', trigger: 'blur' }],
                    // is_invoice:[ { required: true, message: '是否提供发票', trigger: 'blur' }]
                },
                dialogVisible:false,
                form_params:{},
                listDetail: this.$cloneJson(initDetailList),
                dialogVisibleFile:false,
                importDialogVisible:false,
                upFileObj:{
                    ids:[],
                    files:[]
                },
                upFileList:[],
                upload_data : {},
				oss : {
                    host : "",
                },
                downLoadFileDialog:false,
                downFilesList:[],
                statusList:[],
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.scene).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            openBail(){
                
            },
            //添加费用
            addFee(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let contract_no_first = this.selectRow[0].contract_no;
                    let flag = true;
                    this.selectRow.forEach(item=>{
                        if(item.contract_no!=contract_no_first){
                            flag = false;
                        }
                    })
                    if(flag){
                        let arr = new Array();
                        let bill_arr = new Array();
                        this.selectRow.forEach(item=>{
                            arr.push(item.contract_no);
                            bill_arr.push(item.bill_lading_no)
                        })
                        this.isShowCost=!this.isShowCost;
                        this.feeForm.fee_date = new Date();
                        this.feeForm.contract_no = arr[0];                         
                        this.feeForm.bill_lading_no = bill_arr;
                        this.feeForm.bill_lading_no_copy = arr.toString();
                    }else{
                        this.tip("合同号不一致","warning")
                    }
                }
            },
            //保存费用
            saveFee(){
                let arr = new Array();
                this.selectRow.forEach(item=>{
                    arr.push(item.id)
                })
                this.feeForm.finance_order_id = arr;
                let time = this.feeForm.fee_date;
                this.feeForm.fee_date=this.formatTimeZero(this.feeForm.fee_date);
                this.postFuncLoading("/erp/add.pledge.fee",this.feeForm,()=>{
                    this.isShowCost=!this.isShowCost;
                    this.tip("添加成功","success")
                    this.getList();
                },error=>{
                    this.feeForm.fee_date = time;
                    this.tip(error.data.message,"warning")
                })
            },
            //修改
            Edit(){
                let params = JSON.parse(JSON.stringify(this.selectRow));
                if(params.length<1||params.length>1){
                    this.tip("请选择一条修改","warning")
                }else{
                    let arr = new Array();
                    let statuslist = new Array();
                    params.forEach(item=>{
                        arr.push(item.id)
                        statuslist.push(item.status)
                    })
                    this.statusList=statuslist;
                    this.financeFeeForm.ids = arr;
                    this.financeFeeForm.pay_date =  params[0].pay_date==0?'':params[0].pay_date;
                    this.financeFeeForm.tax_date =  params[0].tax_date==0?'':params[0].tax_date;
                    this.financeFeeForm.pay_rate =  params[0].pay_rate;
                    this.financeFeeForm.invoice_no =  params[0].invoice_no;
                    this.isShowEditfinance = true;
                }
            },
            openCargo(){
                this.cargodetailsDialog = true;
                this.postFuncLoading('/erp/pledge.goods.power',{},res=>{
                    this.cargoDetail = res.data.data.data;
                })
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube:4,
                    purchase_amount:2
                },total=>{
                });
            },
            //融资单修改确定
            importFile(){
                let timea =this.financeFeeForm.pay_date;
                let timeb =this.financeFeeForm.tax_date;
                this.financeFeeForm.pay_date = this.formatTimeZero(this.financeFeeForm.pay_date);
                this.financeFeeForm.tax_date = this.formatTimeZero(this.financeFeeForm.tax_date);
                this.financeFeeForm.pay_rate = parseFloat(this.financeFeeForm.pay_rate);
                this.postFuncLoading('/erp/pledge.order.update',this.financeFeeForm,res=>{
                    this.isShowEditfinance = false;
                    this.tip("修改成功","success");
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                    this.financeFeeForm.pay_date = timea;
                    this.financeFeeForm.tax_date = timeb;
                })
            },
            getList(){
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/pledge.overdue.orders",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.tot= res.data.data.total;
                    this.list=res.data.data.data;
                    this.list.forEach((item,index)=>{
                        item.isForeclosure = 1;
                        this.list[index].finance_date = item.finance_date==0?'':this.formatTime(item.finance_date+"000");
                        this.list[index].pay_date = item.pay_date==0?'':this.formatTime(item.pay_date+"000");
                        this.list[index].tax_date = item.tax_date==0?'':this.formatTime(item.tax_date+"000");
                        this.list[index].inbound_date = item.inbound_date==0?'':this.formatTime(item.inbound_date+"000");
                        this.list[index].expiry_date = item.expiry_date==0?'':this.formatTime(item.expiry_date+"000");
                        this.list[index].contract_time = item.contract_time==0?'':this.formatTime(item.contract_time+"000");
                        if(item.agent_tax_status==0){
                            item.tax_date="-";
                        }
                        item.finance_rate = item.finance_rate+'‰'
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },
            getStatistical() {
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.postFunc('/erp/finance.order.statistical',this.params,res=>{
                    this.statistical = res.data.data;
                });
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getRow(row){
                this.selectRow=row;
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getTableEdit(id){},
            getTableDelete(id){},
            getTableSee(id){},
            rowClick(obj){
                this.scene = 'pledge.order.info';
                this.isGlobal = true;
                this.getBillColumn();
                if(obj.name =='order_sn'){
                    this.dialogVisible = true;
                    this.postFunc('/erp/pledge.order.info',{id:obj.id},res=>{
                        this.form_params = res.data.data.info;
                        this.form_params.agent_tax_status=this.form_params.agent_tax_status ==1?'是':'否';
                        // this.form_params.redeem_date = this.formatTime(this.form_params.redeem_date+"000");
                        this.listDetail = res.data.data.details;
                    })
                }
            },
            getToforeclosure(){
                sessionStorage.removeItem("TOADVANCE")
                sessionStorage.setItem("TOADVANCE",1)
                this.$root.$children[0].$children[0].addTab({
                    name: '赎货应付',
                    label: '赎货应付',
                    content: 'bankpayableManager'
                });
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time="";
                this.getList();
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            toggleSelection(row) {
                if(row.isSelect==1){
                    this.$refs.outBoundDetailTable.toggleRowSelection(row);
                }else{
                    return false;
                }
            },
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                this.downFilesList = obj.files;
            },
            bacthUpFile(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upFileObj.ids = arr;
                    if(this.selectRow.length == 1){
                        this.upFileList = JSON.parse(JSON.stringify(this.selectRow[0].files));
                    }
                    this.dialogVisibleFile = true;
                    this.isUpImg = 2;
                }
            },
            saveFile(){
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upFileObj.files = this.upFileList;
                    this.postFuncLoading("/erp/pledge.order.upload",this.upFileObj,()=>{
                        this.tip('上传成功','success');
                        this.dialogVisibleFile = false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            upFileRemove(url){
                this.upFileList.forEach((item,index)=>{
                    if(item.url == url){
                        this.upFileList.splice(index,1)
                    }
                })
            },
            //期初导入
            handleSuccess(res) {
                let obj = new Object();
                obj.url = res.data.base_url;
                obj.name = res.data.filename.substring(res.data.filename.lastIndexOf("/")+1,res.data.filename.length)
                this.upFileList.push(obj)
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            handleSuccessB(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            },
            toWarning(){
                this.$root.$children[0].$children[0].addTab({
                    name: '融资预警',
                    label: '融资预警',
                    content: 'paySummaryDetail'
                });
            },
            excelExport(){
                this.$exportExecl("/erp/pledge.order.export","融资管理",this.params)
            },
            //导出 created by xiong
            exportExcel(){
                this.$exportExecl("/erp/pledge.order.info.export","出库单",{id:this.form_params.id})
            }
        },
        components:{
            tabletem,
            pagination,
            relativeFile
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "isShowEditfinance":function(val){
                if(!val){
                    this.financeFeeForm={
                        pay_date:"",
                        pay_rate:"",
                        tax_date:"",
                        invoice_no:"",
                    }
                }
            },
            'dialogVisible':function(val){
                if(!val){
                    this.form_params={};
                    this.listDetail=this.$cloneJson(initDetailList);
                }
            }
        },
    }
</script>
<style scoped lang="scss">
    .banking_box {
        background-color: #fff;
        margin: 5px 0 0 5px;
        // .show {
        //     display: flex;
        //     padding: 10px;
        //     margin-bottom: 2px;

        //     .item {
        //         flex: 1;
        //         display: flex;
        //         align-items: center;
        //         height: 100px;
        //         margin-right: 10px;
        //         box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
        //         border-radius: 6px;
        //         padding: 0 10px;

        //         .left_icon {
        //             flex: 1;
        //             text-align: left;

        //             .top {
        //                 font-size: 18px;
        //                 color: #000;
        //                 /*font-weight: 500;*/
        //                 display: flex;
        //                 align-items: center;
        //                 justify-content: center;
        //                 .icon_item {
        //                     width: 26px;
        //                     height: 26px;
        //                     background-size: contain !important;
        //                     background-clip:content-box !important;
        //                     margin-right: 10px;
        //                 }
        //                 .fi_order_num{background:url(../../../assets/finance/home_financing.png) no-repeat;}
        //                 .fi_cube{background:url(../../../assets/finance/home_financing_square.png) no-repeat;}
        //                 .fi_amount{background:url(../../../assets/finance/home_financing_money.png) no-repeat;}
        //                 .fi_interest{background:url(../../../assets/finance/home_financing_interest.png) no-repeat;}
        //                 .fi_ensure_amount {background: url(../../../assets/finance/home_financing_total.png) no-repeat;}
        //                 .fi_alert {background: url(../../../assets/finance/home_financing_time.png) no-repeat;}
        //             }
        //             .bottom {
        //                 margin-top: 15px;
        //                 font-size: 26px;
        //                 text-align: center;
        //                 /*font-weight: 700;*/
        //             }

        //         }


        //     }
        // }
        .depositButton{background-color: #F9A602;color: #fff;padding: 8px 20px;float: left;margin-right: 15px;}

        .total {
            display: flex;
            margin: 2px 0;
            font-size: 14px;
            color: #000;

            .total_left {
                flex-basis: 60px;
                background-color: #fff;
                margin-right: 2px;
                padding: 10px;
                font-weight: 600;
            }

            .total_right {
                flex: 1;
                background-color: #fff;
                padding: 10px;
                text-align: left;

                span {
                    font-weight: 600;
                    margin-right: 20px;
                }
            }
        }

        .pag_box {
            background-color: #fff;
        }
        .huoquanImg{width: 30px;float: left;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
        .editLeft{float: left;}
    }
    .upFileOutBox .upFileBox{width:100%;margin-bottom:10px;border-radius: 5px;box-shadow: 0 0 5px #ccc;padding:2px 10px;margin-top:10px;}
    .upFileOutBox .upFile{display: block;float: left;font-size: 14px;}
    .upFileOutBox .upFileRemove{width:15px;height:15px;float:right;cursor:pointer;margin-top:2px;}
    .upFileOutBox .uploadFileAdd{width:60px;height:50px;display: block;margin:auto;margin-top:10px;}
    .upFileOutBox .upload-demo{width:100%;height:100px;overflow: hidden;}
    .upFileOutBox .uploadTitle{width:100%;text-align: center;font-size: 14px;margin-top:5px;}

    .upFileBox:hover{transform: translateY(-2px);cursor: pointer;}
    .upFileUnder{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileTop{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;top:0;border-radius: 35px;}
    .upFileLeft{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileRight{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;top:0;border-radius: 35px;}
    .upFileBox:hover .upFileUnder{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileTop{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileLeft{width:0;height:100%;border-left:1px solid #b21111;}
    .upFileBox:hover .upFileRight{width:0;height:100%;border-left:1px solid #b21111;}
</style>